import * as React from 'react';
import { PiralInstance } from 'piral-core';
import { Spinner } from '@smapiot/components';
import { account } from './http';

interface AppProps {
  instance: PiralInstance;
  pages: Record<string, React.FC>;
  onChanged(cb: () => void): void;
}

export const App: React.FC<AppProps> = ({ instance, pages, onChanged }) => {
  const UserApp = React.lazy(() => import('./UserApp'));
  const AnonymousApp = React.lazy(() => import('./AnonymousApp'));
  const [loggedIn, setLoggedIn] = React.useState(account);

  React.useEffect(() => {
    onChanged(() => setLoggedIn(account()));
  }, []);

  return (
    <React.Suspense fallback={<Spinner />}>
      {loggedIn ? <UserApp instance={instance} /> : <AnonymousApp instance={instance} pages={pages} />}
    </React.Suspense>
  );
};
